export default __webpack_public_path__ + "static/media/mielDehesa.20992bc3.JPG";